export default __webpack_public_path__ + "static/media/variluxG9-bg-2.3d26a036.png";